import { render, staticRenderFns } from "./warehousedistribute.vue?vue&type=template&id=8e897966&"
import script from "./warehousedistribute.vue?vue&type=script&lang=js&"
export * from "./warehousedistribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports